import { render, staticRenderFns } from "./BodyWeightPerBird.vue?vue&type=template&id=6a111113&scoped=true"
import script from "./BodyWeightPerBird.vue?vue&type=script&lang=js"
export * from "./BodyWeightPerBird.vue?vue&type=script&lang=js"
import style0 from "./BodyWeightPerBird.vue?vue&type=style&index=0&id=6a111113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a111113",
  null
  
)

export default component.exports